type ThankYouPageProps = {
  onContinue: () => void;
};

export default function ThankYouPage({ onContinue }: ThankYouPageProps) {
  return (
    <main className="entry-container">
      <header className="entry-header">
        <div className="entry-brand">
          <img
            src="/logo-white.png"
            alt="Calm But Capable"
            className="entry-logo-small"
          />

          <div>
            <div className="entry-brand-name">Calm But Capable</div>
            <div className="entry-brand-subtitle">The Sanctuary</div>
          </div>
        </div>

        <button className="entry-login-button" onClick={onContinue}>
          Continue
        </button>
      </header>

      <section className="entry-card">
        <div className="entry-logo-wrap">
          <img
            src="/logo-white.png"
            alt="Calm But Capable"
            className="entry-logo"
          />
        </div>

        <p className="entry-eyebrow">Calm But Capable</p>

        <h1 className="entry-title">Your spot is reserved.</h1>

        <p className="entry-tagline">
          Check your email for confirmation and upcoming workshop updates.
        </p>

        <p className="entry-subtitle">
          Small consistent steps create meaningful progress over time.
        </p>

        <p className="entry-small-print">
          Take a moment to note today’s step in your diary before moving on.
        </p>

        <button className="entry-button thank-you-button" onClick={onContinue}>
          Continue to The Sanctuary
        </button>
      </section>
    </main>
  );
}
